import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import Step5View from './Step5-view';
import {loadOptionsByDDType} from '../../actions/loadOptionsByDDType';
import {checkRequiredValues} from '../../utils/forms/checkRequiredValues';
import {ddTypes} from '../../constants/dropdownTypes';
import types from '../../types';
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import {useIntl} from "react-intl";
import {trackEvent} from "../../utils/trackEvent";

const Step5 = ({
                 submitStep,
                 regType,
                 payload,
                 language,
                 prevCompletedStepSign,
                 prevCompletedStepSignFalse
               }) => {
  const {
    isDelivery,
    practiceArea,
    job,
    clients,
    area,
    scopeOfWork
  } = payload;
  const initialValues = {
    practiceArea: isDelivery ? {value: 37} : practiceArea ? {value: practiceArea} : '',
    job: isDelivery ? {value: 625} : job ? {value: job} : '',
    clients: clients ? clients.map(item => {
      return {value: item}
    }) : '',
    area: area ? area.map(item => {
      return {value: item}
    }) : '',
    scopeOfWork: scopeOfWork ? {value: scopeOfWork} : '',
  };

  const handlePracticeAreaChange = ({setFieldValue, values}) => selected => {
    if (values.practiceArea.value !== selected.value) {
      setFieldValue('job', {value: null, label: ''});
    }
  };

  const handleMultiplySelectChange = ({setFieldValue, field}) => selected => {
    if (!selected) return;

    const allIsLastSelected = selected[selected.length - 1].value === 100;
    const optionIsSelectedAfterAll = selected[0].value === 100 && selected.length > 1;

    if (allIsLastSelected) {
      setFieldValue(field, selected.filter(item => item.value === 100));
    }
    if (optionIsSelectedAfterAll) {
      setFieldValue(field, selected.filter(item => item.value !== 100));
    }
  };

  const validate = values => {
    let errors = {};
    errors = checkRequiredValues(values, errors);

    return errors;
  };

  const {formatMessage} = useIntl();

  const handleSubmit = values => {
    const {
      practiceArea: {value: practiceArea},
      job: {value: job},
      clients,
      area,
      scopeOfWork: {value: scopeOfWork},
    } = values;

    submitStep({
      step: 5,
      data: {
        regType,
        practiceArea,
        job,
        clients: flatValues(clients),
        area: flatValues(area),
        scopeOfWork,
        prevCompletedStepSign
      },
    })
      .then(checkNextStepAndGo)
      .then(() => prevCompletedStepSignFalse())
      .then(() => trackEvent('signup_step',
          {
            step_number: 5,
            step_name_en: 'Field of activity',
            step_name_he: formatMessage({id: 'step5.page.title', defaultMessage: ''}),
            regType
          }
        )
      )
      .catch(err => console.error({err}));
  };

  const flatValues = selected => selected.map(item => item.value);

  const loadOptions = ddType => (inputValue, callback) => {
    loadOptionsByDDType({callback, language, ddType})
  };

  const loadCustomOptions = (ddType, params) => (inputValue, callback) => {
    loadOptionsByDDType({callback, language, ddType, params})
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validate}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {({values, setFieldValue, isValid, submitCount}) => (
        <Step5View
          loadOptions={{
            practiceArea: loadOptions(ddTypes.practiceAreaItems),
            jobTitle: loadCustomOptions(ddTypes.jobTitleItems, {subValue: values.practiceArea.value}),
            customerTypes: loadOptions(ddTypes.customerTypesItems),
            workRegion: loadOptions(ddTypes.workRegionTypes),
            workCapacity: loadOptions(ddTypes.workCapacityTitles)
          }}
          values={values}
          setFieldValue={setFieldValue}
          onChange={{
            practiceAreaChange: handlePracticeAreaChange({setFieldValue, values}),
            customerChange: handleMultiplySelectChange({setFieldValue, values, field: 'clients'}),
            workRegionChange: handleMultiplySelectChange({setFieldValue, values, field: 'area'}),
          }}
          isValid={isValid || submitCount === 0}
        />
      )}
    </Formik>
  )
};

Step5.propTypes = {
  ...types.router,
  regType: PropTypes.string,
  payload: PropTypes.object,
  language: PropTypes.string,
  submitStep: PropTypes.func
};

export default Step5;
